<template>
  <!-- Login -->
  <BaseCard
    class="mx-auto flex max-w-120 flex-col gap-4 p-4 md:mt-6 md:w-120 md:p-6"
  >
    <TextTitle>Inloggen</TextTitle>
    <!-- Incorrect credentials -->
    <MessageComponent v-if="showCredentialsError" in-card color="danger">
      <p>De combinatie van e-mailadres en wachtwoord is niet geldig.</p>
    </MessageComponent>
    <!-- Form -->
    <form action="" class="flex w-full flex-col gap-4" @submit.prevent>
      <InputField
        v-model="inputEmail"
        type="text"
        label="E-mailadres"
        :disabled="isLoading"
        :state-error="inputError"
      />
      <InputField
        v-model="inputPassword"
        type="password"
        :disabled="isLoading"
        label="Wachtwoord"
        :state-error="inputError"
      />
      <div class="flex flex-wrap justify-between gap-4">
        <BaseButton color="primary" :loading="isLoading" @click="login">
          Inloggen
        </BaseButton>
        <RouterLink :to="{ name: 'forgot-password' }">
          <BaseButton color="primary" minimal class="text-primary!">
            Wachtwoord vergeten
          </BaseButton>
        </RouterLink>
      </div>
    </form>
  </BaseCard>
</template>

<script setup>
import { ref, watch } from "vue"
import { triggerEvent } from "@/services/plausibleService.js"
import useNavigationStore from "@/stores/navigationStore.js"
import useNotificationStore from "@/stores/notificationStore.js"
import useUserStore from "@/stores/userStore.js"
import {
  TextTitle,
  BaseCard,
  BaseButton,
  InputField,
} from "@repowerednl/ui-component-library"
import MessageComponent from "@/components/information/MessageComponent.vue"

const navigationStore = useNavigationStore()
const notificationStore = useNotificationStore()
const userStore = useUserStore()
const inputEmail = ref("")
const inputPassword = ref("")
const isLoading = ref(false)
const inputError = ref(false)
const showCredentialsError = ref(false)

function onLoginSuccess() {
  notificationStore.pushToast("Je bent ingelogd.")
  navigationStore.goToInitialRoute()
}

function onLoginUnknown() {
  inputError.value = true
  showCredentialsError.value = true
  isLoading.value = false
}

function onLoginFail(error) {
  notificationStore.pushError(
    "Inloggen niet mogelijk",
    `Er ging iets mis bij het inloggen. Vernieuw de pagina en probeer het opnieuw. (code: ${error.code})`,
  )
  isLoading.value = false
}

function onLoadMeteringPointsFail(error) {
  useNotificationStore().pushError(
    "Fout bij het laden van installaties",
    `Installaties of bovenliggende allocatiepunten en portfolios konden niet
    worden opgehaald. Probeer het later opnieuw. (code: ${error.code})`,
    "load-metering-points-fail",
  )
}

function login() {
  isLoading.value = true
  userStore.login(
    inputEmail.value,
    inputPassword.value,
    onLoginSuccess,
    onLoginUnknown,
    onLoginFail,
    onLoadMeteringPointsFail,
  )
  triggerEvent("account:login")
}

watch([inputEmail, inputPassword], () => {
  inputError.value = false
})
</script>
